module.exports = __webpack_public_path__ + "img/index-bg1.4e1b82e5.png";